export default __webpack_public_path__ + "static/media/template1.3ba652f9.svg";